import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService, Core2Config} from '../../shared';
import {GenericDocContainerModel} from '../../../../../../models/aggregates/generic_doc';

@Injectable({providedIn: 'root'})
export class CustomerPurchaseGoodsReceivedNotes extends BaseApiTemplateService<GenericDocContainerModel> {

  constructor(http: HttpClient) {
    super();
    this.endpoint_path =  Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.GENERIC_PREFIX + 'customer-purchase-goods-received-notes';
    this.httpClient = http;
  }
}
